module.exports = "../../static/img/videoposter.c2ca62a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/videoposter.jpg
// module id = gipn
// module chunks = 1